import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// report-common
import { getReportReducers } from '../../report-common';
// feature service-vendor
import * as A from './actions';
//////////////////////////////////////////////////

export const initial = {
  configs: {},
  profile: {},
  documentList: [],
  branchConfigs: {},
  documentsFilter: null,
  geofencingZoneList: [],
  integrationInfoList: [],
  integrationAuditList: [],
  collapsedGroup: {
    profile: true,
    documents: true,
    payToLocation: true,
    geofencingZone: true,
    primaryLocation: true,
    integrationInfo: true,
    integrationAudit: true,
  },
};

const {
  setReports,
  selectItem,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemSuccess,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  setInitialStateOmitReport,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers(initial);

// configs
const getServiceVendorConfigsSuccess = (state, data) => (
  P.$set('configs', G.mapConfigValuesByName(data), state)
);

// service vendor
const updateServiceVendorSuccess = (state, data) => (
  P.$set('profile', data, state)
);

const toggleServiceVendorFormGroup = (state, groupName) => (
  P.$toggle(`collapsedGroup.${groupName}`, state)
);

const getServiceVendorSuccess = (state, data) => (
  P.$set('profile', data, state)
);

const sendListToIntegrationSuccess = (state, data) => P.$set(
  'itemList',
  R.map(
    (entity) => {
      const guid = G.getGuidFromObject(entity);
      const branches = R.pathOr(null, [guid], data);

      if (R.isNil(branches)) return entity;

      return R.assoc(GC.GRC.INTEGRATION_INFO_EXTERNAL_DIVISION_NAME, R.prop(guid, data), entity);
    },
    state.serviceVendorList,
  ),
  state,
);

const getServiceVendorIntegrationListSuccess = (state, data) => (
  P.$set('integrationInfoList', data, state)
);

const getServiceVendorIntegrationAuditListSuccess = (state, data) => (
  P.$set('integrationAuditList', data, state)
);

const getServiceVendorDocListSuccess = (state, data) => (
  P.$set('documentList', data, state)
);

const createOrUpdateServiceVendorDocSuccess = (state, { data, isUpdate }) => {
  if (isUpdate) {
    const { documentList } = state;

    const index = R.findIndex(R.propEq(G.getGuidFromObject(data), GC.FIELD_GUID), documentList);

    return P.$set(`documentList.${index}`, data, state);
  }

  return P.$add('documentList', data, state);
};

const deleteServiceVendorDocSuccess = (state, index) => (
  P.$drop(`documentList.${index}`, state)
);

const setDocumentsFilter = (state, filter) => P.$set('documentsFilter', filter, state);

const getUserGeneralListByServiceVendorBranchGuidSuccess = (state, data) => {
  const mapped = R.map(({ guid, ...user }) => ({
    [GC.FIELD_VALUE]: guid,
    [GC.FIELD_LABEL]: R.prop('fullText', G.getUserInfo(user)),
  }), R.or(data, []));

  return P.$set('userGeneralList', mapped, state);
};

// geofencing zone
const deleteGeoFencingZoneSuccess = (state, guid) => P.$drop(`geofencingZoneList.${guid}`, state);

const toggleGeoFencingZoneDetails = (state, { guid }) => (
  P.$toggle(`geofencingZoneList.${guid}.expanded`, state)
);

const receivedGeoFencingZoneListSuccess = (state, data) => {
  if (G.isNilOrEmpty(data)) return P.$set('geofencingZoneList', {}, state);

  const indexedList = R.compose(
    G.indexByGuid,
    G.mapIndexed((item, index) => R.mergeRight(
      item,
      { index, expanded: false, disabled: G.notPropEq(G.getAmousCurrentBranchGuidFromWindow(), GC.BRANCH_GUID, item) },
    )),
  )(data);

  return P.$set('geofencingZoneList', indexedList, state);
};

const receivedGeoFencingZoneSuccess = (state, data) => {
  const { guid, [GC.BRANCH_GUID]: branchGuid } = data;

  const { geofencingZoneList } = state;

  const expanded = R.pathOr(false, [guid, 'expanded'], geofencingZoneList);
  const disabled = G.notEquals(G.getAmousCurrentBranchGuidFromWindow(), branchGuid);
  const index = R.pathOr(R.length(geofencingZoneList), [guid, 'index'], geofencingZoneList);
  const dataWithTableProps = R.mergeRight(data, { index, expanded, disabled });
  const newList = R.assoc(guid, dataWithTableProps, geofencingZoneList);

  return P.$set('geofencingZoneList', newList, state);
};

export default createReducer({
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.deleteItemSuccess]: deleteItemSuccess,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.getServiceVendorSuccess]: getServiceVendorSuccess,
  [A.setInitialStateOmitReport]: setInitialStateOmitReport,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
  [A.getUserGeneralListByServiceVendorBranchGuidSuccess]: getUserGeneralListByServiceVendorBranchGuidSuccess,
  // configs
  [A.getServiceVendorConfigsSuccess]: getServiceVendorConfigsSuccess,
  // service vendor
  [A.setDocumentsFilter]: setDocumentsFilter,
  [A.updateServiceVendorSuccess]: updateServiceVendorSuccess,
  [A.toggleServiceVendorFormGroup]: toggleServiceVendorFormGroup,
  [A.sendListToIntegrationSuccess]: sendListToIntegrationSuccess,
  [A.deleteServiceVendorDocSuccess]: deleteServiceVendorDocSuccess,
  [A.getServiceVendorDocListSuccess]: getServiceVendorDocListSuccess,
  [A.createOrUpdateServiceVendorDocSuccess]: createOrUpdateServiceVendorDocSuccess,
  [A.getServiceVendorIntegrationListSuccess]: getServiceVendorIntegrationListSuccess,
  [A.getServiceVendorIntegrationAuditListSuccess]: getServiceVendorIntegrationAuditListSuccess,
  // geofencing zone
  [A.deleteGeoFencingZoneSuccess]: deleteGeoFencingZoneSuccess,
  [A.toggleGeoFencingZoneDetails]: toggleGeoFencingZoneDetails,
  [A.receivedGeoFencingZoneSuccess]: receivedGeoFencingZoneSuccess,
  [A.receivedGeoFencingZoneListSuccess]: receivedGeoFencingZoneListSuccess,
}, initialState);
